// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__8RPhz","rotation":"Preloader_rotation__Xtqkx"};